module.exports = __webpack_public_path__ + "static/media/phone.0b8122b3.svg";